module.exports = __webpack_public_path__ + "img/vip_lost_icon.8fe8c8b1.png";